// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-line-stepped';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M17.424 17.424H.576V.576' />
    <path d='M.576 4.608H4.68V3.096h4.104v2.232h4.176V1.224h4.104M.576 9.576H4.68V7.704h4.104v2.232h4.176V8.424h4.104M.576 12.384H4.68v2.592h4.104v-2.592h4.176v1.656h4.104' />
  </g>
);

export const viewBox = '0 0 18 18';
